import {
    collection,
    doc,
    setDoc,
    deleteDoc,
    getDocs,
    getDoc,
  } from "firebase/firestore";
  import { db } from "../auth/firebase";

  
  /* =========================
     ADD TO WISHLIST
  ========================= */
  export const addToWishlist = async (userId, movie) => {
    const ref = doc(
      db,
      "users",
      userId,
      "wishlist",
      movie.id.toString()
    );
  
    await setDoc(ref, {
      id: movie.id,
      title: movie.title || movie.name,
      poster: movie.poster_path,
  
      // ✅ THIS IS THE MISSING PIECE
      providers: movie.providers || [],
  
      createdAt: Date.now(),
    });
  };

  
  
  /* =========================
     REMOVE FROM WISHLIST
  ========================= */
  export const removeFromWishlist = async (userId, movieId) => {
    if (!userId || !movieId) {
      console.error("Invalid removeFromWishlist args", {
        userId,
        movieId,
      });
      return;
    }
  
    const ref = doc(
      db,
      "users",
      userId,
      "wishlist",
      movieId.toString()
    );
  
    await deleteDoc(ref);
  };
  
  /* =========================
     GET WISHLIST
  ========================= */
  export const getWishlist = async (userId) => {
    const ref = collection(db, "users", userId, "wishlist");
    const snap = await getDocs(ref);
  
    return snap.docs.map((doc) => ({
      id: doc.id,       // ✅ FIRESTORE DOC ID
      ...doc.data(),
    }));
  };
  /* =========================
     CHECK IF MOVIE IS IN WISHLIST
  ========================= */
  export const isInWishlist = async (userId, movieId) => {
    const ref = doc(
      db,
      "users",
      userId,
      "wishlist",
      movieId.toString()
    );
    const snap = await getDoc(ref);
    return snap.exists();
  };

  export const getWishlistCount = async (userId) => {
    if (!userId) return 0;
    const ref = collection(db, "users", userId, "wishlist");
    const snap = await getDocs(ref);
    return snap.size;
  };

  
  